import axios from './axios';

export default {
  doctorInfo(params) {
    return axios.post('/onlineDrug/link/getDoctorById', params);
  },
  getDoctors(params) {
    return axios.post('/onlineDrug/link/getDoctors', params);
  },
  getOrderList(params) {
    return axios.post('/onlineDrug/link/getOrdersById', params);
  },
  submitConsultationOrder(params) {
    return axios.post('/onlineDrug/recipeOrder/submitConsultationOrder', params);
  },
  // 公告接口
  getNotice(params) {
    return axios.post('/announcement/search?' + 'xAnnouncementId=' + params);
  },
  // //取消订单接口
  handleNoPay(params) {
    return axios.post('/consultingOrder/updateStatus', params);
  },
  // 患者资料列表
  patientList(patientId) {
    return axios.get(`/thePatientCardController/thePatientList?patientId=${patientId}`);
  },
  // 患者资料详情
  patientDetail(id) {
    return axios.get(`/thePatientCardController/queryThePatient?id=${id}`);
  },
  // 新增患者资料
  insertThePatient(data) {
    return axios.post('/thePatientCardController/insertThePatient', data);
  },
  // 删除就诊人
  delThePatient(id) {
    return axios.get(`/thePatientCardController/deleteThePatient?id=${id}`);
  },
  // 获取验证码
  getQrCode(mobile) {
    return axios.get(`/user/sendsms?mobile=${mobile}`);
  },
  //验证身份证
  userIsIdentifyNum(data){
    return axios.post('/authenticationController/userIsIdentifyNum', data);
  },
  getUpImage(){
    return axios.post('/picture/updatePictureUrl');
  },
  orderDetail(orderCode) {
    return axios.get(
      `/consultingOrderController/getConsultingQuestionnaire?orderCode=${orderCode}`
    );
  },
   // 患者资料列表
   presentContent(thankId) {
    return axios.get(`/doctorController/queryThankInfo?thankId=${thankId}`);
  },

  // 查询医生出诊日历接口
  queryDoctorCalendar(doctorId, month) {
    return axios.get(`/doctorController/queryCalendar?doctorId=${doctorId}&month=${month}`)
  }

};
